module.exports = __webpack_public_path__ + "static/img/letter_large@2x.9cd948e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/birthday/letter_large@2x.png
// module id = NsJP
// module chunks = 1